import { Inject, NgModule } from '@angular/core';
import { BcConfigService } from 'common/config/provider';
import { WindowService } from 'shared/services/window/window.service';
import { NewRelicTelemetryService } from 'common/telemetry/new-relic/new-relic-telemetry.service';
import { GenesysCloudConfigService } from 'common/genesys-cloud-config';
import { TELEMETRY_SERVICE } from './telemetry-service.token';
import { TelemetryService } from './telemetry.service';
import { NoOpTelemetryService } from './no-op-telemetry.service';

const initTelemetryService = (configService: BcConfigService,
                              windowService: WindowService,
                              genesysCloudConfigService: GenesysCloudConfigService): TelemetryService => {
  if (!!configService.current.telemetry?.newRelic) {
    return new NewRelicTelemetryService(configService, windowService, genesysCloudConfigService);
  }
  return new NoOpTelemetryService();
};

@NgModule({
  providers: [
    {
      provide: TELEMETRY_SERVICE,
      useFactory: initTelemetryService,
      deps: [BcConfigService, WindowService, GenesysCloudConfigService]
    }
  ]
})
export class TelemetryModule {
  // Do not delete this, since this injection ensures eager creation of service
  constructor(@Inject(TELEMETRY_SERVICE) private readonly telemetryService: TelemetryService) {
  }
}
